<div class="home-bg"></div>
<div class="home-content-wrapper">
  @if (!showLoginRegisterForm && !showOtpLoginForm && !showForgotPasswordForm) {
    <!-- Trip Search Form Card Structure -->
    <div class="trip-search-form-container">
      <div class="trip-search-form-card">
        <h2 class="form-title">Your Cab, Just a Click Away</h2>
        
        <div class="form-divider"></div>
         
        <app-trip-search-form #tripSearchForm [data]="searchFormData"></app-trip-search-form>
        

      </div>
    </div>
  } @else if (showLoginRegisterForm) {
    <!-- Login Register Form Card Structure -->
    <div class="login-register-form-container">
      <div class="login-register-form-card">
        <app-login-register-form (switchToOtp)="switchToOtpLogin()" (switchToForgotPassword)="switchToForgotPassword()" (loginSuccess)="onLoginSuccess()">
        </app-login-register-form>
      </div>
    </div>
  } 
  

</div>

